import { render } from "./ModalItemTaskChanged.vue?vue&type=template&id=7d82d68a&ts=true"
import script from "./ModalItemTaskChanged.vue?vue&type=script&lang=ts"
export * from "./ModalItemTaskChanged.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__